module.exports = __webpack_public_path__ + "static/media/pointantbrand.7639e12b.png";